import React, { useMemo, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchContactUsData } from "../../redux/contactUs/contactUsSlice";
import TextStyles from "../../components/Elements/TextStyles/TextStyles";
import { ReactComponent as GreenEye } from "../../assets/svgs/greenEye.svg";
import { Tables } from "../../components/Elements/Tables/Tables";
import SearchBar from "../../components/Elements/Search/SearchBar";
import CardsBorder from "../../components/Cards/CardsBorder";
import { ReactComponent as FilterIcon } from "../../assets/svgs/filter-icon.svg";
import { Button } from "antd";
import { Badge } from "../../components/Elements/TextStyles/Badge";
import ContactUsFilter from "./DailogBox/ContactUsFilter";

const ContactUs = () => {
  const dispatch = useDispatch();
  const { contacts, loading } = useSelector((state) => state.contactUs);

  const [filterOpen, setFilterOpen] = useState(false);
  const [filterData, setFilterData] = useState("");
  const headers = useMemo(
    () => [
      { label: "Sr. No.", key: "serial" },
      { label: "First Name", key: "firstName" },
      { label: "Last Name", key: "lastName" },
      { label: "Email", key: "email" },
      { label: "Phone Number", key: "phone" },
      { label: "Status", key: "status" },
      { label: "Message", key: "message" },
      { label: "Action", key: "action" },
    ],
    []
  );

  useEffect(() => {
    dispatch(fetchContactUsData());
  }, [dispatch]);

  const formattedData = useMemo(() => {
    return contacts.map((item, index) => ({
      serial: index + 1,
      firstName: item.firstName,
      lastName: item.lastName,
      email: item.email,
      phone: item.phone,
      status: (
        <div className="flex justify-center">
          <Badge
            text={item.status}
            color={item.status === "Active" ? "green" : item.status === "Pending" ? "yellow" : "blue"}
          />
        </div>
      ),
      message: (
        <div
          style={{
            textAlign: "center",
            wordWrap: "break-word",
            wordBreak: "break-word",
            whiteSpace: "normal",
            maxWidth: "120px",
            margin: "0 auto",
          }}
        >
          {item.message}
        </div>
      ),
      action: (
        <div className="flex gap-2 justify-center items-center cursor-pointer hover:opacity-80">
          <GreenEye />
        </div>
      ),
    }));
  }, [contacts]);

  return (
    <div
      style={{
        padding: "20px",
        backgroundColor: "#fff",
        overflowX: "hidden",
        width: "100%",
        boxSizing: "border-box",
      }}
      className="min-h-screen"
    >
      <div>
        <div>
          <div
            className="flex justify-end  text-xs"
            style={{ fontFamily: "Calibri" }}
          >
            <p>Home</p>
            <span> / </span>
            <TextStyles color="gradient"> Contact Us</TextStyles>
          </div>
          <div className="flex items-center gap-2 text-xl font-bold">
            <div className="pt-4 px-2">
              <TextStyles color="gradient"> Contact Us</TextStyles>
            </div>
          </div>
        </div>
        <CardsBorder>
          <div className="flex justify-between mb-4 px-6">
            <div className="flex gap-4">
              <div
                style={{
                  background: "#B6D4D933",
                  height: "40px",
                }}
                className="px-4 border  border-gray-300 rounded-md text-gray-400 text-base font-light"
              >
                <p
                  style={{
                    fontFamily: "Calibri",
                    fontWeight: "300",
                    fontSize: "16px",
                    lineHeight: "24px",
                    letterSpacing: "0%",
                  }}
                  className="pt-2"
                >
                  TOTAL CONTACTS {formattedData.length}
                </p>
              </div>
              <SearchBar width="300px" />
            </div>
            <div className="flex gap-4">
              <Button
                type="secondary"
                onClick={() => setFilterOpen(true)}
                style={{
                  background: "#B6D4D9",
                  border: "solid 1px #06513D",
                }}
                className="text-[14px] !bg-[#E6EDEB]  hover:!bg-[#F8F8F8] text-[#06513D] font-normal px-4 py-6"
              >
                <FilterIcon /> FILTER
              </Button>
            </div>
          </div>

          <Tables data={formattedData} headers={headers} loading={loading} />

        </CardsBorder>   

        {filterOpen && (
          <ContactUsFilter
            onOpen={filterOpen}
            onClose={() => setFilterOpen(false)}
            setFilterData={setFilterData}
            initialStatus={filterData}
          />
        )}
      </div>
    </div>
  );
};

export default ContactUs;
